import { render } from "./UserReport.vue?vue&type=template&id=11f60e62"
import script from "./UserReport.vue?vue&type=script&lang=js"
export * from "./UserReport.vue?vue&type=script&lang=js"

import exportComponent from "/usr/frontend/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__